import { getDocument } from 'ssr-window';
import { IdleInterruptSourceEventTarget, IdleInterruptSourceEventTargetOptions } from './interrupt-source-event-target';

/**
 * An interrupt source that uses events on the document element (html tag).
 */
export class IdleInterruptSourceDocument extends IdleInterruptSourceEventTarget {
    constructor(events: string, options?: number | IdleInterruptSourceEventTargetOptions) {
        const document = getDocument();

        super(() => document.documentElement, events, options);
    }

    /**
     * Checks to see if the event should be filtered.
     * @param event - The original event object.
     * @return True if the event should be filtered (don't cause an interrupt); otherwise, false.
     */
    override filterEvent(event: any): boolean {
        // some browser bad input hacks
        if (
            event.type === 'mousemove' &&
            // fix for Chrome desktop notifications
            ((event.originalEvent && event.originalEvent.movementX === 0 && event.originalEvent.movementY === 0) ||
                // fix for webkit fake mousemove
                (event.movementX !== void 0 && !event.movementX) ||
                !event.movementY)
        ) {
            return true;
        }

        return false;
    }
}
